export function getUser() {
  return {
    id: localStorage.getItem("rh-userId"),
    user: localStorage.getItem("rh-user"),
    cf: localStorage.getItem("rh-ativo"),
    token: localStorage.getItem("rh-token"),
    refreshToken: localStorage.getItem("rh-refreshToken"),
  };
}
